<template>
	<div>
		<!-- 图片触发：封面 + 居中播放按钮 -->
		<div class="cover-wrap" @click="showModal">
			<img class="cover-img" :src="thumbnail" :width="120" :height="120" />
			<div class="cover-mask" />
			<div class="cover-play-btn">
				<span class="cover-play-icon" />
			</div>
		</div>

		<!-- 视频弹窗 -->
		<a-modal :title="videoTitle" :visible="visible" :width="modalWidth" :destroyOnClose="true" :footer="null"
			@cancel="closeModal" :bodyStyle="{ padding: '0' }">
			<div class="video-responsive-container">
				<video ref="videoPlayer" class="video-js vjs-fluid vjs-big-play-centered" playsinline></video>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import videojs from 'video.js'
	import 'video.js/dist/video-js.css'

	export default {
		props: {
			videoSrc: String,
			thumbnail: String,
			videoTitle: String,
			aspectRatio: {
				type: String,
				default: '16:9' // 支持 '16:9', '4:3', '1:1'
			}
		},
		data() {
			return {
				visible: false,
				player: null,
				modalWidth: 800 // 默认宽度
			}
		},
		computed: {
			paddingBottom() {
				const [w, h] = this.aspectRatio.split(':');
				return `${(h / w) * 100}%`;
			}
		},
		methods: {
			showModal() {
				this.visible = true;
				this.$nextTick(() => {
					this.initPlayer();
					this.adjustModalSize();
				});
			},

			closeModal() {
				if (this.player) {
					window.removeEventListener('resize', this.handleResize);
					this.player.dispose();
					this.player = null;
				}
				this.visible = false;
			},
			adjustModalSize() {
				// 根据窗口宽度动态调整Modal大小
				const windowWidth = window.innerWidth;
				this.modalWidth = Math.min(800, windowWidth * 0.9);

				// 如果是移动端，使用全屏模式
				if (windowWidth < 768) {
					this.modalWidth = '100%';
				}
			},
			initPlayer() {
				if (this.player) {
					return;
				}

				const videoElement = this.$refs.videoPlayer;
				if (!videoElement) {
					return;
				}

				this.player = videojs(videoElement, {
					controls: true,
					autoplay: true,
					fluid: true, // 关键：启用fluid模式
					aspectRatio: this.aspectRatio, // 设置比例
					sources: [{
						src: this.videoSrc,
						type: this.getVideoType(this.videoSrc)
					}]
				})

				// 窗口大小变化时重新布局
				window.addEventListener('resize', this.handleResize);
			},

			destroyPlayer() {
				if (this.player) {
					this.player.pause();
					this.player.dispose();
					this.player = null;
				}
			},
			handleResize() {
				if (this.player) {
					this.player.dimensions(
						this.$refs.videoPlayer.offsetWidth,
						this.$refs.videoPlayer.offsetHeight
					)
				}
				this.adjustModalSize();
			},

			getVideoType(url) {
				if (url.includes('.m3u8')) {
					return 'application/x-mpegURL';
				}
				if (url.includes('.mpd')) {
					return 'application/dash+xml';
				}
				return 'video/mp4';
			}
		},
		beforeDestroy() {
			this.destroyPlayer();
		}
	}
</script>

<style scoped>
	.cover-wrap {
		position: relative;
		display: inline-block;
		cursor: pointer;
	}
	.cover-img {
		display: block;
		object-fit: cover;
	}
	.cover-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.25);
		pointer-events: none;
		transition: background 0.2s ease;
	}
	.cover-wrap:hover .cover-mask {
		background: rgba(0, 0, 0, 0.4);
	}
	.cover-play-btn {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		pointer-events: none;
	}
	.cover-play-icon {
		width: 54px;
		height: 54px;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.5);
		border: 3px solid rgba(255, 255, 255, 0.95);
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
	}
	.cover-play-icon::after {
		content: '';
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 12px 0 12px 22px;
		border-color: transparent transparent transparent #fff;
		margin-left: 6px;
	}
	.cover-wrap:hover .cover-play-icon {
		background: rgba(0, 0, 0, 0.6);
		border-color: #fff;
	}

	.thumbnail {
		width: 200px;
		cursor: pointer;
		transition: transform 0.3s;
	}

	.thumbnail:hover {
		transform: scale(1.03);
	}

	.video-responsive-container {
		position: relative;
		padding-bottom: v-bind(paddingBottom);
		background: #000;
	}

	/* 覆盖Video.js样式 */
	.video-responsive-container>>>.video-js {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}


</style>